import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFullscreenComponent } from "./med-icon-fullscreen.component";

@NgModule({
  declarations: [
    MedIconFullscreenComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFullscreenComponent,
  ],
})
export class MedIconFullscreenModule { }
